import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    Input,
    ChangeDetectorRef,
    ViewChild,
    AfterViewInit
  } from '@angular/core';
  import { cloneDeep } from 'lodash';
  
  import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
  import { ResolvableComponent } from '@ispm/core/decorators/resolvable-component.decorator';
  import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
  import { FormGroup } from '@angular/forms';
  import { IoptionElemet } from '@ispm/shared/interfaces/IoptionElemet';
  import { MultiselectComponent } from '@wuitk/angular/components/multiselect';
  
  @Component({
    selector: 'gen-multi-select',
    templateUrl: './multi-select.component.html',
    styleUrls: ['./multi-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
  })
  @ResolvableComponent()
  export class MultiSelectComponent implements OnInit, AfterViewInit, IWidgetItem {
  
    constructor(private _changeDetector: ChangeDetectorRef) { }
  
    public widgetFormInstance: FormGroup;
    public config: IdynamicFormItem;
  
    public widgetUpdateValueCallback: (value) => void;
  
    set widgetConfig(_itemConfig: IdynamicFormItem) {
      this.config = _itemConfig;
      this.widgetUpdateValueCallback.apply(this, [this.data, true]);
    }
  
    set options(value: IoptionElemet[]) {
      this.selectionItems = [];
      if (value) {
        const groups = value.reduce((list, item) => {
          if (!item.group) { return list; }
          if (list.indexOf(item.group) >= 0) { return list; }
          return [...list, item.group];
        }, []);
        if (groups.length > 0) {
          // items are in groups, reformat
          this.selectionItems = { };
          groups.forEach(group => {
            this.selectionItems[group] = value.filter(item => item.group === group);
          });
          const other = value.filter(item => !item.group);
          if (other.length > 0) {
            this.selectionItems['OTHER'] = other;
          }
        } else {
          this.selectionItems = value;
        }
      }
      this._changeDetector.markForCheck();
    }
  
    set widgetData(widgetData: any) {
      this.data = cloneDeep(widgetData);
      this._changeDetector.markForCheck();
      this._changeDetector.detectChanges();
    }
    @Input()
    public data;
  
    public selectionItems: IoptionElemet[] | { [key: string]: IoptionElemet[] } = [];
  
    @ViewChild(MultiselectComponent) private selectComponent: MultiselectComponent;
  
    public isArray = Array.isArray;
  
    ngOnInit() { }
  
    ngAfterViewInit(): void {
      // disable close on scroll
      this.selectComponent.onScrolling = () => { };
    }
  
  
    public onRemove($event) {
      const newValue = this.widgetFormInstance.get(this.config.name).value.filter(item => item !== $event.value);
      this.widgetFormInstance.get(this.config.name).setValue(newValue);
    }
  }
  